import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  // firmasList:[],
  currentOrden: JSON.parse(localStorage.getItem("currentOrden")) || ''
};
export const mutations = {
  // GET_FIRMAS({ context }, firmas) {
  //   let firmas_array = [];
  //   Object.entries(firmas).forEach(([key, val]) => firmas_array.push(val));
  //   return (state.firmasList = firmas_array);
  // },
  SHOW_SENTENCIA ({ context }, sentencia) {
    state.currentOrden = Object.assign({}, sentencia);
    localStorage.setItem("currentOrden", JSON.stringify(state.currentOrden));
  }
};
export const actions = {

  // SAVE_FIRMA_MAGISTRADO({ commit }, data) {
  //   // console.log(data);
  //     return new Promise((resolve, reject) => {
  //       commit("SET_LOADING", true);
  //       ApiService.post(data)
  //         .then(response => {
  //           commit("SET_LOADING", false);
  //           resolve(response);
  //         })
  //         .catch(error => {
  //           commit("SET_LOADING", false);
  //         reject(error);
  //       });
  //   });
  // },

  CREATE_SENTENCIA({ commit }, data) {
    console.log(data);
      return new Promise((resolve, reject) => {
        commit("SET_LOADING", true);
        ApiService.post(data)
          .then(response => {
            commit("SET_LOADING", false);
            resolve(response);
          })
          .catch(error => {
            commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  GET_SENTENCIAS({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          // commit("GET_SENTENCIAS", response.data.data.sentencias);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  SHOW_SENTENCIA({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          commit("SHOW_SENTENCIA", response.data.data.sentencia);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  // GET_SENTENCIAS_TOCA({ commit }, data) {
  //   return new Promise((resolve, reject) => {
  //     commit("SET_LOADING", true);
  //     ApiService.get(data)
  //       .then(response => {
  //         commit("SET_LOADING", false);
  //         // commit("GET_SENTENCIAS_TOCA", response.data.data.sentencias);
  //         resolve(response);
  //       })
  //       .catch(error => {
  //         commit("SET_LOADING", false);
  //         reject(error);
  //       });
  //   });
  // },

  // EDIT_MULTIFIRMA({ commit }, data) { //axios, mandar parametros para post
  //   return new Promise((resolve, reject) => {
  //     commit("SET_LOADING", true);
  //     ApiService.put(data)//funcion de ApiService
  //       .then(response => {
  //         commit("SET_LOADING", false);
  //         // commit("EDIT_MULTIFIRMA", response.data);//mandar a mutations
  //         resolve(response);
  //       })
  //       .catch(error => {
  //         commit("SET_LOADING", false);
  //         reject(error);
  //       });
  //   });
  // },

  // GET_FIRMAS({ commit }, data) {
  //   return new Promise((resolve, reject) => {
  //     commit("SET_LOADING", true);
  //     ApiService.get(data)
  //       .then(response => {
  //         commit("SET_LOADING", false);
  //         // console.log(response.data);
  //         commit("GET_FIRMAS", response.data.data.firmas);
  //         resolve(response);
  //       })
  //       .catch(error => {
  //         commit("SET_LOADING", false);
  //         reject(error);
  //       });
  //   });
  // },

  // GET_FIRMADOS({ commit }, data) {
  //   return new Promise((resolve, reject) => {
  //     commit("SET_LOADING", true);
  //     ApiService.get(data)
  //       .then(response => {
  //         commit("SET_LOADING", false);
  //         // console.log(response.data);
  //         // commit("GET_FIRMADOS", response.data.data.firmas);
  //         resolve(response);
  //       })
  //       .catch(error => {
  //         commit("SET_LOADING", false);
  //         reject(error);
  //       });
  //   });
  // },

};

export const getters = {
  // firmasList: state => state.firmasList
};
